
export default {
  name: 'dialog-notice',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: undefined
    },
    title: {
      type: String,
      default: '通知'
    },
    plain: {
      type: Boolean,
      default: false
    },
    body: {
      type: String,
      default: ''
    }
  },
  computed: {
    opened: function () {
      if (this.visible !== undefined) {
        return this.visible;
      }
      return this.value;
    }
  },
  methods: {
    close: function () {
      this.$emit('input', false);
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  }
};
